<template>
  <el-dialog
    width="632px"
    :visible="true"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div slot="title">
      <div class="el-dialog__title">
        <template>
          {{ $t('CampaignsList_ManageLabelsDialog_Title') }}
        </template>
      </div>
    </div>
    <rest-list-editable
      :top-data="topData"
      :payload="labelsFetchEndpoint"
      :add-endpoint="rowAddEndpoint"
      :update-endpoint="rowUpdateEndpoint"
      :watch-payload="false"
      :after-fetch="afterFetch"
      @dataLoaded="setData($event)"
      @selection-change="selectionChange($event)"
      @row-updated="onRowUpdate()"
      :rules="rules"
      ref="list"
      :max-height="500"
      :clear-mask="true"
    >
      <el-table-column type="selection" align="center" />
      <rest-list-column
        prop="name"
        :title="$t('CampaignsList_ManageLabelsDialog_LabelName')"
        :editable="true"
      >
        <template slot="input-edit" slot-scope="{ model }">
          <el-input
            :placeholder="
              $t('CampaignsList_ManageLabelsDialog_LabelName_Placeholder')
            "
            v-model="model.name"
          />
        </template>
      </rest-list-column>
      <rest-list-column-actions v-if="!readonly" :editable="true">
        <template slot-scope="scope">
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.name"
            :delete-message="
              $t('CampaignsList_ManageLabelsDialog_Label_Delete', {
                label: scope.row.name
              })
            "
            :html-warning-msg="true"
            :clear-mask="true"
          />
        </template>
      </rest-list-column-actions>
    </rest-list-editable>
    <span slot="footer">
      <el-button
        v-if="!readonly"
        class="create-label-btn"
        type="primary"
        plain
        icon="el-icon-circle-plus"
        @click="addRow"
      >
        {{ $t('CampaignsList_ManageLabelsDialog_Button_CreateLabel') }}
      </el-button>
      <el-button type="primary" @click="applyLabels">
        <span>{{ $t('CampaignsList_ManageLabelsDialog_Button_Apply') }}</span>
        <i class="el-icon-arrow-right el-icon--right" />
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import { projectEndpoint, projectUrl } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestApi from '@/core/services/RestApi'
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'

export default {
  name: 'ManageLabelsDialog',
  components: {
    RestListActionDelete,
    RestListColumnActions,
    RestListEditable,
    RestListColumn
  },
  props: {
    labels: Array,
    foreignId: Number,
    endpoint: String
  },

  data() {
    return {
      skipFirstChange: false,
      selectedItems: [],
      topData: [],
      data: {}
    }
  },

  created() {
    this.selectedItems = this.labels
  },

  computed: {
    labelsFetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'labels'
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'labels'
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    },

    rules() {
      return {
        name: { required: true }
      }
    }
  },

  methods: {
    afterFetch() {
      this.$nextTick(_ => {
        this.selectionChange(this.selectedItems)
      })
    },

    selectionChange(items) {
      // filter triggers selectionChange, so skip it for the first time and select the previous elements
      if (this.skipFirstChange) {
        this.skipFirstChange = false
        this.toggleSelection(this.selectedItems)
      } else {
        this.selectedItems = items
      }
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.list.$refs.restList.$refs['el-table'].toggleRowSelection(
            row
          )
        })
      } else {
        this.$refs.list.$refs.restList.$refs['el-table'].clearSelection()
      }
    },

    setData(data) {
      this.topData = []
      this.data = Object.assign({}, this.data, data)

      if (this.selectedItems.length) {
        this.selectedItems.forEach((val, index) => {
          // Update selected items and place them at the top of the table
          let updatedSelectedItem = data.find(item => item.id === val.id)
          if (updatedSelectedItem) {
            this.selectedItems[index] = updatedSelectedItem
          }
        })
        this.topData = this.selectedItems
        this.skipFirstChange = true
      }
    },

    handleClose() {
      EventBus.$emit('manageLabelsDialog', null)
    },

    applyLabels() {
      const url = projectUrl(`${this.endpoint}/${this.foreignId}/labels`)
      RestApi.patch(url, {
        labels: this.selectedItems
      })
        .then(() => {
          EventBus.$emit('applyLabels', {
            selection: this.selectedItems
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    addRow() {
      const model = {
        id: '',
        name: ''
      }
      this.$refs.list.addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `labels/${row.id}`
      })
    },

    rowUpdateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `labels/${row.id}`
      })
    },

    onRowUpdate() {
      const tableRef = this.$refs.list.$refs.restList.$refs['el-table']
      tableRef.toggleRowSelection(tableRef.data[0])
    }
  }
}
</script>

<style scoped>
>>> .el-checkbox__input.is-indeterminate .el-checkbox__inner,
>>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1d87c8;
  border-color: #1d87c8;
}

.create-label-btn {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/ManageLabelsDialog.vue